import { configureStore } from '@reduxjs/toolkit'
import applicantsSlice, { IApplicantsState } from './Slice/applicantsSlice'
import userReducer, { IUserState } from './Slice/userSlice'
import UserDataSlice, {IUserData} from "./Register/UserDataSlice";


export interface IRootState{
    user: IUserState,
    applicants: IApplicantsState
    UserData :IUserData|null,
}

export const store = configureStore({
  reducer: {
      user: userReducer,
      applicants: applicantsSlice,
      UserData:UserDataSlice
  },
})